import React from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';
import _ from 'underscore';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getAmountTotalCellStyles } from '../styles';

function AmountTotalCellItem({
  amountType, amountValue, className,
}) {
  const classes = useDefaultStyles(getAmountTotalCellStyles);
  const hasGreenColor = _.isString(amountValue) && amountValue[0] === '+';
  return (
    <div className={classname('amount-total-cell-item', className, classes.AmountTotalItem)}>
      <span className="amount-total-cell-item-label">{amountType}</span>
      <span className={classname('amount-total-cell-item-value', hasGreenColor && classes.GreenColor)}>{amountValue}</span>
    </div>
  );
}

AmountTotalCellItem.propTypes = {
  amountType: PropTypes.string.isRequired,
  amountValue: PropTypes.string.isRequired,
  className: PropTypes.string,
};
AmountTotalCellItem.defaultProps = {
  className: '',
};

export function AmountTotalCell({
  i18n,
  totalSpendAmount,
  totalAdjustmentAmount,
  totalBudgetChangeAmount,
  withPadding,
}) {
  const classes = useDefaultStyles(getAmountTotalCellStyles);

  return (
    <div className={classname('amount-total-cell', classes.AmountTotalCell, withPadding && classes.AmountTotalCellWithPadding)}>
      {totalSpendAmount && <AmountTotalCellItem
        amountType={i18n.getString(_TL_('Total spend'))}
        amountValue={totalSpendAmount}
        className="amount-total-cell-spend"
      />}
      {totalAdjustmentAmount && <AmountTotalCellItem
        amountType={i18n.getString(_TL_('Total system adjustment'))}
        amountValue={totalAdjustmentAmount}
        className="amount-total-cell-adjustment"
      />}
      {totalBudgetChangeAmount && <AmountTotalCellItem
        amountType={i18n.getString(_TL_('Total budget change'))}
        amountValue={totalBudgetChangeAmount}
        className="amount-total-cell-budget-change"
      />}
    </div>
  );
}

AmountTotalCell.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  totalSpendAmount: PropTypes.string,
  totalAdjustmentAmount: PropTypes.string,
  totalBudgetChangeAmount: PropTypes.string,
  withPadding: PropTypes.bool,
};

AmountTotalCell.defaultProps = {
  totalSpendAmount: null,
  totalAdjustmentAmount: null,
  totalBudgetChangeAmount: null,
  withPadding: false,
};
